import PropTypes from 'prop-types';
import { PureComponent, Fragment } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'redux';

import SchoolDataSimple from '../SchoolDataSimple';
import { withRtl } from '../hoc';
import style from './SchoolInfoAccordionK.scss';
import messages from '../../locale/messages';
import { SchoolAccordion } from '../SchoolAccordion';
import {customisedIntlFormatMessage} from '../../utils/helpers';
import RatingBlocks from '../SchoolInfoRatingBlocks/SchoolInfoRatingBlocks';

const localMessages = defineMessages({
  less: {
    id: 'schoolinfo.overview.less',
    defaultMessage: 'Show less',
    description: 'Show less text',
  },
  schoolWebsite: {
    id: 'schoolinfo.schoolWebsite',
    defaultMessage: 'School website',
    description: 'School website',
  },
  schoolEmail: {
    id: 'schoolinfo.schoolEmail',
    defaultMessage: 'School email',
    description: 'School email',
  },
  schoolPhone: {
    id: 'schoolinfo.schoolPhone',
    defaultMessage: 'School phone',
    description: 'School phone',
  },
  schoolAddress: {
    id: 'schoolinfo.schoolAddress',
    defaultMessage: 'School address, opens in new window',
    description: 'School address',
  },
  accordionPerformance: {
    id: 'schoolinfo.accordionPerformance',
    defaultMessage: 'Performance',
    description: 'Accordion label for school performance',
  },
  accordionAcademics: {
    id: 'schoolinfo.accordionAcademics',
    defaultMessage: 'Academics',
    description: 'Accordion label for school Academics',
  },
  accordionActivities: {
    id: 'schoolinfo.accordionActivities',
    defaultMessage: 'Activities',
    description: 'Accordion label for school Activities',
  },
  accordionOtherFeatures: {
    id: 'schoolinfo.accordionOtherFeatures',
    defaultMessage: 'Other Features',
    description: 'Accordion label for school Other Features',
  },
  accordionAffiliatedSchools: {
    id: 'schoolinfo.accordionAffiliatedSchools',
    defaultMessage: 'Affiliated Schools',
    description: 'Accordion label for school Affiliated Schools',
  },
  accordionAccessibility: {
    id: 'schoolinfo.accordionAccessibility',
    defaultMessage: 'Accessibility',
    description: 'Accordion label for school Accessibility',
  },
  accordionAccessibilityMoreInfo: {
    id: 'schoolinfo.accordionAccessibilityMoreInfo',
    defaultMessage: 'Accessibility More Informatiion',
    description: 'Accordion label for Accessibility More Information',
  },
  accordionOpenHouses: {
    id: 'schoolinfo.accordionOpenHouses',
    defaultMessage: 'Open Houses & Information Sessions',
    description: 'Accordion label for school Open Houses & Information Sessions',
  },
  accordionMoreInfo: {
    id: 'schoolinfo.accordionMoreInfo',
    defaultMessage: 'More Info',
    description: 'More Info',
  },
  schoolDataELLPrograms: {
    id: 'schoolinfo.schoolDataELLPrograms',
    defaultMessage: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
    description: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
  },
  schoolDataLangaugeCourses: {
    id: 'schoolinfo.schoolDataLangaugeCourses',
    defaultMessage: 'LANGUAGE COURSES',
    description: 'LANGUAGE COURSES',
  },
  schoolDataAPCourses: {
    id: 'schoolinfo.schoolDataAPCourses',
    defaultMessage: 'ADVANCED PLACEMENT (AP) COURSES',
    description: 'ADVANCED PLACEMENT (AP) COURSES',
  },
  schoolDataAdvancedCourses: {
    id: 'schoolinfo.schoolDataAdvancedCourses',
    defaultMessage: 'ADVANCED COURSES',
    description: 'ADVANCED COURSES',
  },
  schoolDataDiplomaEndorsements: {
    id: 'schoolinfo.schoolDataDiplomaEndorsements',
    defaultMessage: 'DIPLOMA ENDORSEMENTS',
    description: 'DIPLOMA ENDORSEMENTS',
  },
  schoolDataSports: {
    id: 'schoolinfo.schoolDataSports',
    defaultMessage: 'SCHOOL SPORTS',
    description: 'SCHOOL SPORTS',
  },
  schoolDataSportsCoed: {
    id: 'schoolinfo.schoolDataSportsCoed',
    defaultMessage: 'PSAL SPORTS - COED',
    description: 'PSAL SPORTS - COED',
  },
  schoolDataSportsGirls: {
    id: 'schoolinfo.schoolDataSportsGirls',
    defaultMessage: 'PSAL SPORTS - GIRLS',
    description: 'PSAL SPORTS - GIRLS',
  },
  schoolDataSportsBoys: {
    id: 'schoolinfo.schoolDataSportsBoys',
    defaultMessage: 'PSAL SPORTS - BOYS',
    description: 'PSAL SPORTS - BOYS',
  },
  schoolStatsGraduate: {
    id: 'schoolinfo.schoolStatsGraduate',
    defaultMessage: 'of students graduate in four years',
    description: 'percentage of students of graduate. A percent precedes this string (ie 76%) ',
  },
  schoolStatsEnrollCollege: {
    id: 'schoolinfo.schoolStatsEnrollCollege',
    defaultMessage: 'of students enroll in college or career programs',
    description:
      'percentage of students of enroll in college or career programs. A percent precedes this string (ie 76%) ',
  },
  schoolStatsAttendance: {
    id: 'schoolinfo.schoolStatsAttendance',
    defaultMessage: 'student attendance',
    description: 'percentage of student attendance. A percent precedes this string (ie 76%) ',
  },
  schoolStatsSaftey: {
    id: 'schoolinfo.schoolStatsSaftey',
    defaultMessage: 'of students feel safe in the hallways, bathrooms, locker room, and cafeteria',
    description: 'percentage of students who feel safe. A percent precedes this string (ie 76%) ',
  },
  schoolStatsSafteyK: {
    id: 'schoolinfok.schoolStatsSaftey',
    defaultMessage: 'of teachers say that students are safe in the hallways, bathrooms, locker rooms, and cafeteria of their school',
    description: 'percentage of students who feel safe. A percent precedes this string (ie 76%) ',
  },
  schoolStatsParentsSatisfaction: {
    id: 'schoolinfo.schoolStatsParentsSatisfaction',
    defaultMessage: 'of parents are satisfied with their child’s education',
    description: 'percentage of students whose parents are satisified. A percent precedes this string (ie 76%) ',
  },
  schoolStatsVariety: {
    id: 'schoolinfo.schoolStatsVariety',
    defaultMessage:
      'of students feel that this school offers a wide enough variety of programs, classes, and activities to keep them interested in school',
    description:
      'percentage of student who like the variety the school offers. A percent precedes this string (ie 76%) ',
  },
  schoolStatsCoreCourses: {
    id: 'schoolinfo.schoolStatsCoreCourses',
    defaultMessage: 'of students passed core courses',
    description: 'percentage of students who passed core courses. A percent precedes this string (ie 76%) ',
  },
  schoolStatsStateEla: {
    id: 'schoolinfo.schoolStatsStateEla',
    defaultMessage: 'of students scored at Level 3 or 4 on the State English Test',
    description:
      'percentage of students who of students scored at Level 3 or 4 on the State English Test. ' +
      'A percent precedes this string (ie 76%) ',
  },
  schoolStatsStateMath: {
    id: 'schoolinfo.schoolStatsStateMath',
    defaultMessage: 'of students scored at Level 3 or 4 on the State Math Test',
    description:
      'percentage of students who of students scored at Level 3 or 4 on the State Math Test. ' +
      'A percent precedes this string (ie 76%) ',
  },
  middleSchoolDataSports: {
    id: 'schoolinfo.middleSchoolDataSports',
    defaultMessage: 'CHAMPS SPORTS',
    description: 'CHAMPS SPORTS',
  },
  middleSchoolDataSportsCoed: {
    id: 'schoolinfo.middleSchoolDataSportsCoed',
    defaultMessage: 'CHAMPS SPORTS - COED',
    description: 'CHAMPS SPORTS - COED',
  },
  middleSchoolDataSportsGirls: {
    id: 'schoolinfo.middleSchoolDataSportsGirls',
    defaultMessage: 'CHAMPS SPORTS - GIRLS',
    description: 'CHAMPS SPORTS - GIRLS',
  },
  middleSchoolDataSportsBoys: {
    id: 'schoolinfo.middleSchoolDataSportsBoys',
    defaultMessage: 'CHAMPS SPORTS - BOYS',
    description: 'CHAMPS SPORTS - BOYS',
  },
  middleSchoolAcceleratedClasses: {
    id: 'schoolinfo.middleSchoolAcceleratedClasses',
    defaultMessage: 'ACCELERATED CLASSES',
    description: 'ACCELERATED CLASSES',
  },
  // frequentlyAttendedHighSchools: {
  //   id: 'schoolinfo.frequentlyAttendedHighSchools',
  //   defaultMessage: 'High schools most frequently attended by students from this school',
  //   description: 'High schools most frequently attended by students from this school',
  // },
  secondaryWebsite: {
    id: 'schoolinfo.secondaryWebsite',
    defaultMessage: 'See the School Quality Snapshot',
    description: 'Text for link to school quality snapshot',
  },
  accordionBAPHelpText: {
    id: 'schoolinfo.accordionBAPHelpText',
    defaultMessage: 'For more details and the most up to date building accessibility information, please view the:',
    description: 'Accordion label for BAP Help Text',
  },
});

class SchoolInfoAccordionK extends PureComponent {
  static defaultProps = {
    address: '',
    bus: '',
    email: '',
    grades: '',
    hours: '',
    phone: '',
    studentCount: '',
    subway: '',
    website: '',
    otherFeatures: [],
    affiliatedSchools: [],
    loggedIn: false,
    admissionProcess: null,
  };
  static propTypes = {
    academics: PropTypes.shape({
      ell: PropTypes.arrayOf(PropTypes.shape({})),
      languageClasses: PropTypes.arrayOf(PropTypes.shape({})),
      apCourses: PropTypes.arrayOf(PropTypes.shape({})),
      diplomaEndorsements: PropTypes.arrayOf(PropTypes.shape({})),
      electivesDescription: PropTypes.string.isRequired,
      opportunities: PropTypes.shape([]),
    }).isRequired,
    accessibility: PropTypes.string.isRequired,
    accordionAnalyticsClick: PropTypes.func.isRequired,
    address: PropTypes.string,
    bus: PropTypes.string,
    contactName: PropTypes.string.isRequired,
    school: PropTypes.shape({}).isRequired,
    email: PropTypes.string,
    loggedIn: PropTypes.bool,
    grades: PropTypes.string,
    hours: PropTypes.string,
    id: PropTypes.number.isRequired,
    // openHouses: PropTypes.string.isRequired,
    otherFeatures: PropTypes.arrayOf(PropTypes.shape({})),
    affiliatedSchools: PropTypes.arrayOf(PropTypes.shape({})),
    performance: PropTypes.shape({
      statStateEla: PropTypes.number,
      statStateMath: PropTypes.number,
      saftey: PropTypes.number,
      statParentsSatisfaction: PropTypes.number,
    }).isRequired,
    phone: PropTypes.string,
    secondary_website: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
      }),
    ).isRequired,
    studentCount: PropTypes.string,
    subway: PropTypes.string,
    website: PropTypes.string,
    intl: PropTypes.shape().isRequired,
    user: PropTypes.shape({}).isRequired,
    admissionProcess: PropTypes.string,
    bapurl: PropTypes.string,
  };

  getAcademicOpportunities = () => {
    const { academics } = this.props;
    const academicsList = academics.opportunities.map(academicItem => (
      <li key={academicItem.name}>{academicItem.name}</li>
    ));
    return <ul className={style.disc}>{academicsList}</ul>;
  };

  getOtherFeatures = () => {
    const { otherFeatures } = this.props;
    if (otherFeatures.length) {
      const otherFeaturesList = otherFeatures.map(item => <li key={item.name}>{item.name}</li>);
      return (
        <Fragment>
          <div className={style.sectionTitle}>
            <FormattedMessage {...localMessages.accordionOtherFeatures} />
          </div>
          <div className={style.schoolDataWrapper}>{otherFeaturesList}</div>
        </Fragment>
      );
    }
    return false;
  };

  getAffiliatedSchools = () => {
    const { affiliatedSchools } = this.props;
    const affiliatedSchoolsList = affiliatedSchools.map(item => <li key={item}>{item}</li>);
    return <ul className={style.disc}>{affiliatedSchoolsList}</ul>;
  };

  getStatDisplay = (statistic, displayString) => {
    if (!statistic) {
      return null;
    }
    return (
      <li>
        <span className={style.stat}>{statistic}%</span> {displayString}
      </li>
    );
  };
  
  getBAP = (bapurl) => {
    const { intl } = this.props
    if (bapurl) {
      return (
        <li>
          {customisedIntlFormatMessage(intl, localMessages.accordionBAPHelpText)}{' '}
          <a target="_blank" rel="noopener" href={bapurl}>Building Accessibility Profile</a>
        </li>
      );
    }
    return null
  };

  getAccessibilityMoreInfo = () => {
    const { school } = this.props;
    const { accessibility_more_info } = school;
    if (!accessibility_more_info) {
      return null;
    }
    const AccessibilityTypeList = accessibility_more_info.split(',').map(AccessibilityTypeItem => (
      <li key={AccessibilityTypeItem}>{AccessibilityTypeItem}</li>
    ));
    return <ul className={style.disc}>{AccessibilityTypeList}</ul>;
  };

  /* eslint-disable react/no-danger */
  render() {
    const { performance, intl, admissionProcess, school } = this.props;
    const { accessibility, bapurl } = this.props;
    return (
      <div className={style.root}>
        <SchoolAccordion
          {...this.props}
          style={style}
        ></SchoolAccordion>
        {( performance.instructionAndPerformanceRating || performance.safetyAndSchoolClimateRating || performance.relationshipsWithFamiliesRating || performance.statStateEla || performance.statStateMath || performance.saftey || performance.statParentsSatisfaction || this.props.secondary_website) && 
        <div label={customisedIntlFormatMessage(intl, messages.generalStringPerformance)}>
        <div className={style.sectionTitle}>
          <FormattedMessage {...messages.generalStringPerformance} />
        </div>
        {performance.instructionAndPerformanceRating && (
            <div className={style.ratingRow}>
              <div className={style.ratingLabel}>
                {performance.instructionAndPerformanceLabel}
              </div>
              <div className={style.ratingValueLine}>
                <RatingBlocks
                    score={performance.instructionAndPerformanceRating.score}
                  />
                <span className={style.ratingText}>
                  {performance.instructionAndPerformanceRating.label}
                </span>
              </div>
            </div>
          )}
        <div className={style.schoolDataWrapper}>
          <ul>
            {this.getStatDisplay(performance.statStateEla, customisedIntlFormatMessage(intl, localMessages.schoolStatsStateEla))}
            {this.getStatDisplay(performance.statStateMath, customisedIntlFormatMessage(intl, localMessages.schoolStatsStateMath))}
          </ul>
        </div>
        {performance.safetyAndSchoolClimateRating && (
            <div className={style.ratingRow}>
              <div className={style.ratingLabel}>
                {performance.safetyAndSchoolClimateLabel}
              </div>
              <div className={style.ratingValueLine}>
                <RatingBlocks
                    score={performance.safetyAndSchoolClimateRating.score}
                  />
                <span className={style.ratingText}>
                  {performance.safetyAndSchoolClimateRating.label}
                </span>
              </div>
            </div>
          )}
        <div className={style.schoolDataWrapper}>
          <ul>
            {admissionProcess && admissionProcess === 'K' && this.getStatDisplay(performance.saftey, customisedIntlFormatMessage(intl, localMessages.schoolStatsSafteyK))}
            {admissionProcess && admissionProcess != 'K' && this.getStatDisplay(performance.saftey, customisedIntlFormatMessage(intl, localMessages.schoolStatsSaftey))}
            {this.getStatDisplay(
              performance.statParentsSatisfaction,
              customisedIntlFormatMessage(intl, localMessages.schoolStatsParentsSatisfaction),
            )}
          </ul>
        </div>
        {performance.relationshipsWithFamiliesRating && (
            <div className={style.ratingRow}>
              <div className={style.ratingLabel}>
                {performance.relationshipsWithFamiliesLabel}
              </div>
              <div className={style.ratingValueLine}>
                <RatingBlocks
                    score={performance.relationshipsWithFamiliesRating.score}
                  />
                <span className={style.ratingText}>
                  {performance.relationshipsWithFamiliesRating.label}
                </span>
              </div>
            </div>
            )}
          {this.props.secondary_website && (
              <div className={style.schoolQualitySnapshotRow}>
                <span dangerouslySetInnerHTML={{
                  __html: performance.school_quality_snapshot_html
                }} />
              </div>
            )}
        </div>}
        {(accessibility && accessibility.length > 0 || bapurl || school.accessibility_more_info ) &&
        <div>
        <div className={style.sectionTitle}>
          <FormattedMessage {...localMessages.accordionAccessibility} />
        </div>
        <div className={style.schoolDataWrapper}>
          <ul>
              <li>{accessibility}</li>
              {this.getBAP(bapurl)}
              {this.getAccessibilityMoreInfo() && (<SchoolDataSimple title={customisedIntlFormatMessage(intl, localMessages.accordionAccessibilityMoreInfo)} stat={this.getAccessibilityMoreInfo()} ></SchoolDataSimple>)}
          </ul>
        </div>
        </div>}
        {admissionProcess && (admissionProcess === 'PK' || admissionProcess === '2K' || admissionProcess === '3K' || admissionProcess === 'K' || admissionProcess === 'EL') && (
          <div>{this.getOtherFeatures()}</div>
        )}
      </div>
    );
  }
}

export { SchoolInfoAccordionK };
export default compose(
  injectIntl,
  withRtl(style),
  withStyles(style),
)(SchoolInfoAccordionK);
